"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createTextLabel;
    }
});
const _RotationGroup = /*#__PURE__*/ _interop_require_default(require("../Group/RotationGroup.js"));
const _KonvaText = /*#__PURE__*/ _interop_require_default(require("./KonvaText.js"));
const _KonvaTextEditable = /*#__PURE__*/ _interop_require_default(require("./KonvaTextEditable.js"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createTextLabel(shape = {}, config = {}) {
    const { rotation, offset = -10, strokeWidth = 4, editable = true, draggable = false, onTextChange = ()=>{} } = config;
    const { label = "", labelSecondary = "", points = [] } = shape;
    const textBoxWidth = 100;
    const textBoxHeight = 17;
    // text group anchor position -->
    const anchor = points[0];
    // relative text box dimensions -->
    const UL = {
        x: 0,
        y: 0
    };
    const LR = {
        x: textBoxWidth,
        y: textBoxHeight
    };
    const nextLine = {
        x: 0,
        y: 15
    };
    // Create main group
    var group = new _RotationGroup.default({
        position: anchor,
        offset: {
            x: offset,
            y: offset
        },
        rotation,
        center: UL
    });
    const editableLabel = new _KonvaTextEditable.default({
        // shape
        label: label,
        points: [
            UL,
            LR
        ]
    }, {
        // config
        strokeWidth,
        padding: 0,
        editable,
        draggable,
        onTextChange
    });
    const secondaryLabel = (0, _KonvaText.default)({
        position: nextLine,
        text: labelSecondary,
        stroke: "black",
        strokeWidth
    });
    // Add shapes to the group
    group.add(editableLabel);
    group.add(secondaryLabel);
    // Return the group
    return group;
}
